<script>
  import OptionCheckbox from "./OptionCheckbox.svelte"

  export let products
  export let selectedProduct
  export let selectedOption
  export let className
  export let title
  export let description
  export let checkmarkList

  let optExists = products.some((product) =>
    product.option_types.some((ot) => ot.category === title)
  )
</script>

{#if optExists}
  <div class="service-container">
    <div class="{className} optionalbe">
      <div class="service-title">{title}</div>
      <div>
        {@html description}
      </div>
      <div class="wrapped">
        {#if checkmarkList.length > 0}
          <ul class="checkmark-list info">
            {#each checkmarkList as item}
              <li>{item}</li>
            {/each}
          </ul>
        {/if}
        <ul class="options">
          {#each products as product}
            {@const opt = product.option_types.find(
              (ot) => ot.presentation === title
            )}
            {#if opt}
              {#each opt.option_values as value}
                <OptionCheckbox
                  {product}
                  {value}
                  {selectedProduct}
                  bind:selectedOption
                />
              {/each}
            {/if}
          {/each}
        </ul>
      </div>
    </div>
  </div>
{/if}
